import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { placementDriveService } from '../../services/api';
import '../../pages/PlacementDrives.css';
import './CompanyPlacementDrives.css';

function CompanyPlacementDrives() {
  const [drives, setDrives] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('All');

  useEffect(() => {
    loadPlacementDrives();
  }, []);

  const loadPlacementDrives = async () => {
    try {
      setLoading(true);
      const data = await placementDriveService.GetNewPlacementDrives();
      setDrives(data);
    } catch (error) {
      console.error('Error loading placement drives:', error);
      alert('Error loading placement drives. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const getStatus = (lastDate) => {
    if (!lastDate) return 'Upcoming';
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const lastDateObj = new Date(lastDate);
    lastDateObj.setHours(0, 0, 0, 0);
    if (lastDateObj < today) return 'Completed';
    if (lastDateObj.getTime() === today.getTime()) return 'Ongoing';
    return 'Upcoming';
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  const getLocation = (drive) => {
    const parts = [];
    if (drive.College?.Name) parts.push(drive.College.Name);
    if (drive.District?.Name) parts.push(drive.District.Name);
    if (drive.State?.Name) parts.push(drive.State.Name);
    if (drive.Country?.Name) parts.push(drive.Country.Name);
    return parts.length ? parts.join(', ') : 'Location not specified';
  };

  const drivesWithStatus = drives.map((d) => ({ ...d, status: getStatus(d.LastDate) }));
  const filteredDrives = filter === 'All' ? drivesWithStatus : drivesWithStatus.filter((d) => d.status === filter);

  if (loading) {
    return (
      <div className="placement-drives company-placement-drives">
        <div className="page-header">
          <div className="container">
            <h1>Placement Drives</h1>
            <p>View placement drives and post vacancies</p>
          </div>
        </div>
        <div className="container" style={{ textAlign: 'center', padding: '3rem' }}>
          <p>Loading placement drives...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="placement-drives company-placement-drives">
      <div className="page-header">
        <div className="container">
          <h1>Placement Drives</h1>
          <p>View placement drives and post vacancies</p>
        </div>
      </div>
      <div className="container">
        <div className="filter-section">
          {['All', 'Upcoming', 'Ongoing', 'Completed'].map((f) => (
            <button
              key={f}
              className={`filter-btn ${filter === f ? 'active' : ''}`}
              onClick={() => setFilter(f)}
            >
              {f}
            </button>
          ))}
        </div>
        {filteredDrives.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '3rem' }}>
            <p>No placement drives found.</p>
          </div>
        ) : (
          <div className="drives-grid">
            {filteredDrives.map((drive) => (
              <div key={drive.Id} className="drive-card">
                <div className="drive-image">
                  <div className="drive-image-icon">🏢</div>
                </div>
                <div className="drive-content">
                  <div className="drive-header">
                    <h3>{drive.Title}</h3>
                    <span className={`status-badge ${drive.status.toLowerCase()}`}>{drive.status}</span>
                  </div>
                  <div className="drive-company">
                    <strong>{drive.Company?.Name || 'Company not specified'}</strong>
                  </div>
                  <div className="drive-info">
                    <p className="drive-venue">📍 {getLocation(drive)}</p>
                    <p className="drive-date">📅 {formatDate(drive.Date)}</p>
                    {drive.LastDate && (
                      <p className="drive-date">⏰ Last Date: {formatDate(drive.LastDate)}</p>
                    )}
                    {drive.College?.Name && (
                      <p className="drive-vacancies">🏫 {drive.College.Name}</p>
                    )}
                  </div>
                  {drive.Description && (
                    <p className="drive-description">
                      {drive.Description.length > 100 ? drive.Description.substring(0, 100) + '...' : drive.Description}
                    </p>
                  )}
                  <Link to="/company-portal/post-vacancy" state={{ driveId: drive.Id }} className="view-details-btn" style={{ textDecoration: 'none', display: 'inline-block' }}>
                    Post Vacancy
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default CompanyPlacementDrives;
